module.exports = __webpack_public_path__ + "static/g-LCervantes-a4723bce87bdcf285d7f0bffe863ae7f.jpg";